import { render, staticRenderFns } from "./TextNoteSummaryButton.vue?vue&type=template&id=689a144c&"
import script from "./TextNoteSummaryButton.vue?vue&type=script&lang=js&"
export * from "./TextNoteSummaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports